import { render, staticRenderFns } from "./play.vue?vue&type=template&id=67a8ccd9&scoped=true&"
import script from "./play.vue?vue&type=script&lang=js&"
export * from "./play.vue?vue&type=script&lang=js&"
import style0 from "./play.vue?vue&type=style&index=0&id=67a8ccd9&prod&lang=less&scoped=true&"
import style1 from "./play.vue?vue&type=style&index=1&id=67a8ccd9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a8ccd9",
  null
  
)

export default component.exports